import { render } from "./UserProgrammi.vue?vue&type=template&id=502810f6&scoped=true"
import script from "./UserProgrammi.vue?vue&type=script&lang=js"
export * from "./UserProgrammi.vue?vue&type=script&lang=js"

import "./UserProgrammi.vue?vue&type=style&index=0&id=502810f6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-502810f6"]])

export default __exports__